import React, { useState } from "react";
import IIntegration from "../../models/IIntegration";
import { Grid, Card, CardHeader, Avatar, Chip, CardContent, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Theme from "../../Theme";
import { H5 } from "../Headers";
import ICompany from "../../models/ICompany";
import { connect } from "react-redux";
import { IApplicationState } from "../../store";
import { selectCompany } from "../../store/context/selectors";
import StyledMarkdown from "../StyledMarkdown";
import ReactMarkdown from "react-markdown";

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const StyledAvatar = styled(Avatar)`
  background-color: ${Theme.colors.buttonSecondary};
`;

const StyledChip = styled(Chip)`
  margin: 0 5px;
`;

const BottomWrapper = styled(Grid)`
  font-size: 18px;
  background-color: #f2f2f2;
  padding: 10px 20px;
`;

export interface IIntegrationCardProps extends IIntegration {
  myCompany?: ICompany;
}

const IntegrationCard = (props: IIntegrationCardProps) => {
  const {
    myCompany,
    ID,
    Name,
    Company: { Name: CompanyName, ID: CompanyID },
    Status: { Name: StatusName },
    System: { Name: SystemName },
    DataDirection: { Name: DataDirectionName },
    Description,
  } = props;

  const [hover, setHover] = useState(false);

  const system = SystemName === "Both" ? "SMS / Qmlativ" : SystemName;

  const dataDir = DataDirectionName === "Both" ? "Import / Export" : DataDirectionName;

  let abbrevCompany = "NA";
  if (CompanyName) {
    abbrevCompany = CompanyName[0].toUpperCase();
    if (CompanyName.length > 1) {
      abbrevCompany += CompanyName[1].toUpperCase();
    }
  }

  return (
    <StyledLink to={`/partnership/integrations/details/${ID}`}>
      <Card elevation={hover ? 5 : 3} onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)}>
        <CardHeader avatar={<StyledAvatar aria-label="logo">{abbrevCompany}</StyledAvatar>} title={Name} subheader={`${system}`} />
        <CardContent>
          <Typography color="textSecondary" component="div">
            <StyledMarkdown content={<ReactMarkdown children={Description} />} />
          </Typography>
        </CardContent>
        <BottomWrapper>
          {myCompany && myCompany.ID === CompanyID && (
            <StyledChip variant="outlined" size="small" avatar={<Avatar>S</Avatar>} label={StatusName} title="Status" />
          )}
          <StyledChip variant="outlined" size="small" avatar={<Avatar>D</Avatar>} label={dataDir} title="Data Direction" />
        </BottomWrapper>
      </Card>
    </StyledLink>
  );
};

export default connect((state: IApplicationState) => ({
  myCompany: selectCompany(state),
}))(IntegrationCard);
